import React from 'react';
import styles from './Relatorios.module.scss';
import { useEffect, useState} from 'react';
import {useParams} from 'react-router-dom';
import { axiosBackend } from '../../../axios/Axios.js';
import GerarRelatorios from "./GerarRelatorios"
import "./Relatorios.css"
import { getToken } from "../../../services/auth";
import loading from '../../../assets/loading.gif';
import Pagination from '@mui/material/Pagination';
import "./Pagination.css";

const Relatorios_ALL = (props) => (
  <>
    {props.relatorios[0] && props.relatorios.map(relatorio => (
      <RelatItem key={relatorio.r_id} photo={relatorio.user.photo} name={relatorio.user.name} detailed={relatorio.detailed} start={relatorio.start} end={relatorio.end} date={relatorio.timestamp} url={relatorio.url} status={relatorio.status}/>
    ))}
  </>
); 


function RelatItem(props) {
  const start = new Date(parseInt(props.start) * 1000);
  const end = new Date(parseInt(props.end) * 1000);
  const date = new Date(parseInt(props.date) * 1000);
  
  return (
    <div className={styles.relat_item}>
        <div className={styles.relat_gerado_por}>
        <img
          className={styles.icon}
          src={props.photo}
          alt="alt text"
        />
        <div className={styles.name}>{props.name}</div>
        </div>
        <div className={styles.others_data}>
          <div className={styles.info}>{(props.detailed ? "Detalhado" : "Simples")}</div>
          <div className={styles.info}>{(String(start.getDate()).padStart(2, '0') + '/' + String(start.getMonth() + 1).padStart(2, '0') + '/' + start.getFullYear())}</div>
          <div className={styles.info}>{(String(end.getDate()).padStart(2, '0') + '/' + String(end.getMonth() + 1).padStart(2, '0') + '/' + end.getFullYear())}</div>
          <div className={styles.info}>{(String(date.getDate()).padStart(2, '0') + '/' + String(date.getMonth() + 1).padStart(2, '0') + '/' + date.getFullYear())}</div>
          <div className={styles.info}>
          {props.status === 200 && <a href={props.url} className={`${styles.download_box} ${styles.download_box_success}`} download>Baixar pdf</a>}
          {props.status === 0 && <div href={props.url} className={`${styles.download_box} ${styles.download_box_loading}`}>Em processamento</div>}
          {props.status !== 200 && props.status !== 0 && <a href={props.url} className={`${styles.download_box} ${styles.download_box_fail}`}>Falha</a>}
          </div>
        </div>
    </div>
  )
}


function Relatorios(props) {
  const RELATORIOS_URL = "/relatorios"
  const [errMsg, setErrMsg] = useState('');
  const [loading, setLoading] = useState(true);
  const [relatorios, setRelatorios] = useState([]);
  const [isModalOpen, setModalOpen] = useState(false);
  const [page, setPage] = useState(1);

  const [relatShow, setRelatShow] = useState([]);

  const [pageTotal, setPageTotal] = useState(1);

  const config = {
    params: {
      "uuid": props.uuid
    },
    headers: {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${getToken()}`
    },
  }

  const handleReload = async (inserted) => {
    axiosBackend.get(RELATORIOS_URL, config)
      .then(res => {
        setRelatorios(res.data.Items)
        setLoading(false);
        setRelatShow(res.data.Items.slice(0, 5))
        setPage(1);
        setPageTotal(Math.ceil(res.data.Items.length/5))
      })
      .catch(err => {
        setErrMsg(err.message);
        setLoading(false);
      });
  };

  const handleChangePage = async (e) => {
    setPage(e)
    setRelatShow(relatorios.slice( ((e-1)*5), (e*5)))
  };

  useEffect(() => {
    setLoading(true);
    axiosBackend.get(RELATORIOS_URL, config)
      .then(res => {
        setRelatorios(res.data.Items)
        setLoading(false);
        setRelatShow(res.data.Items.slice(0, 5))
        setPage(1);
        setPageTotal(res.data.Items.length > 0 ? Math.ceil(res.data.Items.length/5) : 1)
      })
      .catch(err => {
        setErrMsg(err.message);
        setLoading(false);
      });
  }, [props.uuid]);

  return (
    <div className={styles.column_relatorios}>
    <GerarRelatorios handleReload={handleReload} isOpen={isModalOpen} onClose={() => setModalOpen(false)} uuid={props.uuid}/>
    <div className={styles.title_row}>
        <h1 className={styles.title}>Relatórios</h1>
        <button onClick={() => setModalOpen(true)} className={styles.button_generate}>Gerar relatório</button>
    </div>
    <div className={styles.relatorios_main_box}>
      <div className={styles.relat_title}>
          <div className={styles.relat_gerado_por}>
              <div className={styles.name_title}>Gerado por</div>
          </div>
          <div className={styles.others_data}>
            <div className={styles.info_title}>Tipo de relatório</div>
            <div className={styles.info_title}>Data inicial</div>
            <div className={styles.info_title}>Data final</div>
            <div className={styles.info_title}>Gerado em</div>
            <div className={styles.info_title}>Fazer download</div>
          </div>
      </div>
      <div className={styles.relatorios_main_content}>
          <Relatorios_ALL relatorios={relatShow}/>
          <Pagination
            count={pageTotal}
            shape="rounded"
            page={page}
            onChange={(e, value) => handleChangePage(value)}
          />
      </div>
    </div>
    </div>
  );
}

export default Relatorios;